import React from 'react';
import Box from '@material-ui/core/Box';
import TextInput from '@/se/components/inputs/TextInput';
import PhoneInput from '@/se/components/inputs/PhoneInput';
import { withLabel } from '@/se/components/Label';
import AddressInput from '../../AddressInput';
import MarkdownNotesInput from '../../../shared/MarkdownNotesInput';
import { HospitalFormValue } from '../types';

const LabeledName = withLabel('Name')(TextInput) as any;
const LabeledPhone = withLabel('Contact Phone Number')(PhoneInput) as any;

interface GeneralTabProps {
  value: HospitalFormValue;
  onChange: (value: HospitalFormValue) => void;
  disabled?: boolean;
}

const GeneralTab: React.FC<GeneralTabProps> = ({ value, onChange, disabled }) => {
  const handleField = (field: keyof HospitalFormValue) => (val: any) => {
    onChange({ ...value, [field]: val });
  };

  return (
    <Box display="flex" flexDirection="column" style={{ gap: '1rem' }} maxWidth={700}>
      <LabeledName
        value={value.name || ''}
        onChange={handleField('name')}
        disabled={disabled}
        placeholder="e.g. Surgical Care Partners"
        required
      />
      <AddressInput value={value.address || ''} onChange={handleField('address')} disabled={disabled} />
      <LabeledPhone
        value={value.contact || ''}
        onChange={handleField('contact')}
        disabled={disabled}
        placeholder="e.g., (619) 412-9512"
      />
      <MarkdownNotesInput value={value.notes || ''} onChange={handleField('notes')} disabled={disabled} />
    </Box>
  );
};

export default GeneralTab;
